/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Too_Many_RequestsInputs */

const en_us2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many visits from this link. Wait a few minutes.`)
};

const pt_br2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitos acessos por este link. Espere alguns minutos.`)
};

const es_419_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiadas visitas desde este enlace. Espera unos minutos.`)
};

const pt_pt2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demasiados acessos por esta ligação. Espera alguns minutos.`)
};

const fr_fr2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trop de visites via ce lien. Patiente quelques minutes.`)
};

const de_de2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu viele Aufrufe über diesen Link. Warte ein paar Minuten.`)
};

const it_it2_share_too_many_requests = /** @type {(inputs: Share_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troppe visite da questo link. Aspetta qualche minuto.`)
};

/**
* | output |
* | --- |
* | "Too many visits from this link. Wait a few minutes." |
*
* @param {Share_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_too_many_requests = /** @type {((inputs?: Share_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_too_many_requests(inputs)
	if (locale === "es-419") return es_419_share_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_share_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_share_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_share_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_share_too_many_requests(inputs)
	return en_us2_share_too_many_requests(inputs)
});
export { share_too_many_requests as "share.too_many_requests" }